import { IResponse } from './util';

export interface ISoftDeleteBase {
  deletedAt: string;
}

export interface IPersonSoftDelete extends ISoftDeleteBase {
  personId: number;
  firstName: string;
  lastName: string;
  company: string | null;
  email: string | null;
  activities: string | null;
  lastTouchedBy: number | null;
  isVip: boolean;
  legacyUri?: string | null;
}

export interface IPropertySoftDelete extends ISoftDeleteBase {
  propertyId: number;
  name: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  propertyType: string | null;
  units: number | null;
  beds: string | null;
  buildableArea: string | null;
  lotAcres: string | null;
  yearBuilt: number | null;
  lastSaleDate: string | null;
}

export interface ICompanySoftDelete extends ISoftDeleteBase {
  organizationId: number;
  organizationIdGuid: string;
  name: string;
  city: string | null;
  state: string | null;
  companyType: string | null;
  assetClassIds: number[];
  unitCount: number;
  transactionVolume: string | null;
  retailSquareFootage: string | null;
  numberOfAssets: number | null;
  numberOfPeople: number | null;
  lastTouchedAt: string | null;
  lastTouchedBy: string | null;
}

export interface ISoftDeleteFilters {
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDirection?: 'Asc' | 'Desc';
  search?: string;
}

export type IPersonSoftDeleteResponse = IResponse<IPersonSoftDelete[]>;
export type IPropertySoftDeleteResponse = IResponse<IPropertySoftDelete[]>;
export type ICompanySoftDeleteResponse = IResponse<ICompanySoftDelete[]>;

export enum SoftDeleteType {
  Person = 'Person',
  Property = 'Property',
  Company = 'Company'
}